import {Scrollbars} from "react-custom-scrollbars";
import React from "react";


export default function CustomScrollbars(props) {
    const renderThumb = ({style, ...props}) => {
        const thumbStyle = {
            borderRadius: 6,
            backgroundColor: 'rgba(var(--kjuup-accent-rgb), 0.8)'
        };
        return <div style={{...style, ...thumbStyle}} {...props} />;
    };
    return (
        <Scrollbars
            renderThumbHorizontal={renderThumb}
            renderThumbVertical={renderThumb}
            {...props}
        />
    );
}

